import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import linkedin from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import github from "../assets/img/github.svg";
import twitter from "../assets/img/twitter.svg";
import youtube from "../assets/img/youtube.svg";
import { Map } from "./Map";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center footer_item">
          <MailchimpForm />
          <Col size={12} sm={4}>
            <img src={logo} alt="Logo" style={{ width: "90%" }} />
          </Col>
          <Col size={12} sm={4} className="text-center  social_footer">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/shahinoor-alam-4b0328203/"
                target="blank"
              >
                <img src={linkedin} alt="" />
              </a>
              <a href="https://github.com/shahinooriatc" target="blank">
                <img src={github} alt="" />
              </a>
              <a href="https://www.facebook.com/Shahin143alom" target="blank">
                <img src={navIcon2} alt="" />
              </a>
              <a href="https://twitter.com/Shahinooriatc" target="blank">
                <img src={twitter} alt="" />
              </a>
              <a
                href="https://www.instagram.com/shahinooralam21/"
                target="blank"
              >
                <img src={navIcon3} alt="" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCH_onmXcV9JHXdeXJ1qnxGA"
                target="blank"
              >
                <img src={youtube} alt="" />
              </a>
            </div>
            <div className="text-center">
              All Right Reserved By{" "}
              <a
                href="https://www.facebook.com/Shahin143alom"
                target="blank"
                style={{ color: "aqua" }}
              >
                Shahinoor Alam
              </a>{" "}
              © 2022!
            </div>
          </Col>
          <Col xs={12} md={3} sm={4} lg={3} xl={3}>
            <h3> Direct Contact Info:</h3>
            <div>
              <div>
                <strong> Email:</strong>{" "}
                <a
                  href="mailto: shahinooriatc@gmail.com"
                  style={{ color: "aqua" }}
                >
                  shahinooriatc@gmail.com
                </a>
              </div>
              <div>
                <strong> Phone:</strong>{" "}
                <a href="tel:+8801731023633" style={{ color: "aqua" }}>
                  01731 02 36 33
                </a>
              </div>
              <div>
                <strong> Address:</strong> Golden Tower(AirPort
                Road),Amoborkhana Poin,Sylhet-3100, Bangladesh
                <Map />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
